import { css } from 'linaria';

export const swiperStyle = css`
  &&& {
    padding-bottom: 15px;
    margin-bottom: -15px;

    @media (--from-tablet) {
      justify-content: flex-start;
      width: 100%;
      padding: 15px 0;
      margin: -15px 0;
    }

    .swiper-button-prev,
    .swiper-button-next {
      @media (--only-tablet) {
        display: flex;
      }
    }

    .swiper-wrapper {
      justify-content: flex-start;
    }
  }
`;

export const otherSectionStyle = css`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 80px 0;
  margin: 0 auto;
  background-color: var(--background-secondary);

  @media (--to-desktop) {
    padding: 64px 0;
  }
`;

export const otherSectionLayout = css`
  display: block;
`;

export const swiperSlideStyle = css`
  && {
    width: 377px;
    height: unset;
    margin-right: 24px;

    &:last-of-type {
      margin-right: 0;
    }

    @media (--only-desktop) {
      width: 297px;
    }

    @media (--only-tablet) {
      width: 209px;
      margin-right: 16px;
    }

    @media (--only-mobile) {
      width: 204px;
      margin-right: 16px;
    }
  }
`;

export const otherSectionLink = css`
  height: 100%;

  &:hover {
    box-shadow: var(--box-shadow-m);
  }
`;

export const mediaCardContentStyle = css`
  && {
    display: flex;
    flex-direction: column;
    padding: 24px;

    @media (--to-desktop) {
      padding: 24px 16px;
    }
  }
`;

export const cardMediaStyle = css`
  height: 262px;

  @media (--only-desktop) {
    height: 200px;
  }

  @media (--to-desktop) {
    height: 156px;
  }
`;

export const cardTitleStyle = css`
  margin-bottom: 8px;
`;

export const cardDescriptionStyle = css`
  @media (--only-mobile) {
    && {
      font-size: 14px;
      line-height: 18px;
    }
  }
`;
